import httpClient from '../../api/httpClient'
import { caseOf, map } from '../../lib'
import { Paginate } from '../../lib/types/Paginate'

export default {
  namespaced: true,
  state: {
    stores: {},
    languages: [
      { value: '', label: 'All' },
      { value: 'at', label: 'Austria' },
      { value: 'cs', label: 'Czech' },
      { value: 'da', label: 'Danish' },
      { value: 'de', label: 'Deutsch' },
      { value: 'nl', label: 'Dutch' },
      { value: 'en', label: 'English' },
      { value: 'fi', label: 'Finnish' },
      { value: 'fr', label: 'French' },
      { value: 'ie', label: 'Ireland' },
      { value: 'it', label: 'Italian' },
      { value: 'no', label: 'Norwegian' },
      { value: 'pl', label: 'Polish' },
      { value: 'pt', label: 'Portuguese' },
      { value: 'ro', label: 'Romanian' },
      { value: 'ru', label: 'Russian' },
      { value: 'sk', label: 'Slovak' },
      { value: 'es', label: 'Spanish' },
      { value: 'sv', label: 'Swedish' },
      { value: 'uk', label: 'Ukrainian' },
    ],
    filters: {
      query: '',
      group: '',
      language: '',
      status: '',
      provider: '',
      store_type: '',
    },
    pagination: { ...Paginate.defaultState },
    loading: false,
  },

  mutations: {
    update(state, { path, value }) {
      state[path] = value
    },
  },

  getters: {
    storesPerPage: ({ stores, pagination: { current } }) => stores[current] || [],
    groups: (state, getters, rootState, rootGetters) =>
      caseOf(rootGetters['storeGroups/groups'], {
        Done: (groups) => map(groups, ({ id, name }) => ({ label: name, value: id })).unshift({ label: 'All', value: '' }),
        _: () => [],
      }),
  },

  actions: {
    getStores({ commit, state }, page = 1) {
      commit('update', { path: 'loading', value: true })
      const params = { ...state.filters, page }
      const { pagination } = state

      const url = '/admin/stores'
      Paginate.setCurrentPage({ pagination, page, commit, url, params })
        .then((response) => {
          if (response) {
            const { current_page, data } = response.data
            let value = { [current_page]: data }
            if (current_page !== 1) {
              value = { ...state.stores, ...value }
            }
            commit('update', { path: 'stores', value })
          }
        })
        .catch((err) => {
          console.error(err)
        })
        .finally(() => {
          commit('update', { path: 'loading', value: false })
        })
    },
    destroyStore({ state, commit }, { store }) {
      return httpClient
        .delete(`/stores/${store.id}`)
        .then((res) => {
          if (res.status === 200) {
            const value = state.stores.filter((stateStore) => stateStore.id !== store.id)
            commit('update', { path: 'stores', value })
          }
        })
        .catch((err) => {
          console.error(`Couldn't delete store (id = ${store.id}), `, err)
        })
    },
  },
}
